import React from "react";
import styles from "../styles/Header.module.css";
import logo from "../assets/logo.webp";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <img src={logo} alt="Hodson Timber" className={styles.logo} />
      </div>
    </header>
  );
};

export default Header;